interface DaashLogoProps {
  className?: string
}

export function DaashLogo({ className }: DaashLogoProps) {
  return (
    <span className={`text-[22px] font-black italic font-tight text-daash-red leading-none ${className ?? ""}`}>
      Daash
    </span>
  )
}
